import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalHeader: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.modal-header',
		defaultMessage: 'Workload by assignee',
		description: 'Header of the workload by assignee modal',
	},
	closeModalButtonAriaLabel: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.close-modal-button-aria-label',
		defaultMessage: 'Close modal',
		description: 'Aria label for close workload by assignee summary modal button',
	},
	closeModalButtonLabel: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.close-modal-button-label',
		defaultMessage: 'Done',
		description: 'Label for close workload by assignee summary modal button',
	},

	includeSubtasksToggleLabel: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.include-subtasks-toggle-label',
		defaultMessage: 'Include subtasks in estimates',
		description: 'Label for toggle to include estimates on subtasks in the total for each assignee',
	},
	closeModalButtonLabelOld: {
		id: 'backlog.card-list.work-load-by-assignee.summary-modal.close-modal-button-label-old',
		defaultMessage: 'Close',
		description: 'Label for close workload by assignee summary modal button',
	},
});
